import {UIService} from "../UIService";
import {ProductDataService} from "../../services/productDataService";
import {ProductDataStore} from "../../stores/productDataStore";
import {PlisseSimpleSelectService} from "./plisseSimpleSelectService";

export class PlisseSimpleSelectUIService {
    private uiService: UIService;
    private productDataService: ProductDataService;
    private productDataStore: ProductDataStore;
    private simpleBlindService: PlisseSimpleSelectService;

    constructor() {
        this.uiService = new UIService();
        this.productDataService = new ProductDataService();
        this.productDataStore = new ProductDataStore();
        this.simpleBlindService = new PlisseSimpleSelectService();
    }

    public initializePlisseDriveSelector() {
        let plisseDrives = this.productDataStore.getAvailableOptionsByName('plisseDrives');

        plisseDrives.forEach(drive => {
            const option = this.createPlisseDriveOption(drive);
            if (drive.id === this.productDataStore.getSelectedOptionIdByName('plisseDrive')) {
                this.uiService.setSelectedOption(option);
            }

            option.addEventListener('click', (event: any) => {
                this.productDataService.updateSelectedOptionByName('plisseDrive', drive.id, true);
                this.uiService.resetSelectionsByPartName('plisseDrive');
                this.uiService.setSelectedOption(event.currentTarget);
            });
        });

        const resetButton = this.uiService.getResetButtonByModule('plisseDrive');
        resetButton.addEventListener('click', this.simpleBlindService.resetPlisseDrive);
    }

    public initializePlisseMontageTypeSelector() {
        let plisseMontageTypes = this.productDataStore.getAvailableOptionsByName('plisseMontageTypes');

        plisseMontageTypes.forEach(montageType => {
            const option = this.createPlisseMontageTypeOption(montageType);
            if (montageType.id === this.productDataStore.getSelectedOptionIdByName('plisseMontageType')) {
                this.uiService.setSelectedOption(option);
            }

            option.addEventListener('click', (event: any) => {
                this.productDataService.updateSelectedOptionByName('plisseMontageType', montageType.id, true);
                this.uiService.resetSelectionsByPartName('plisseMontageType');
                this.uiService.setSelectedOption(event.currentTarget);
            });
        });

        const resetButton = this.uiService.getResetButtonByModule('plisseMontageType');
        resetButton.addEventListener('click', this.simpleBlindService.resetPlisseMontageType);
    }

    private createPlisseDriveOption(drive) {
        const option = this.uiService.createConfiguratorOption('plisseDrive');

        this.uiService.setAttributeToElement(
            option,
            'nf-option-id',
            drive.id
        );

        this.uiService.setAttributeToElement(
            this.uiService.getElementByAttribute('nf-value-key', 'img', option),
            'src',
            drive.attributes.imgSrc
        );

        this.uiService.addTextInElement(
            this.uiService.getElementByAttribute('nf-value-key', 'name', option),
            drive.attributes.name
        );

        const price = '+' + drive.attributes.priceAfterDiscount + `kr`;
        this.uiService.addTextInElement(
            this.uiService.getElementByAttribute('nf-value-key', 'price', option),
            price
        );

        return option;
    }

    private createPlisseMontageTypeOption(montageType) {
        const option = this.uiService.createConfiguratorOption('plisseMontageType');

        this.uiService.setAttributeToElement(
            option,
            'nf-option-id',
            montageType.id
        );

        this.uiService.setAttributeToElement(
            this.uiService.getElementByAttribute('nf-value-key', 'img', option),
            'src',
            montageType.attributes.imgSrc
        );

        this.uiService.addTextInElement(
            this.uiService.getElementByAttribute('nf-value-key', 'name', option),
            montageType.attributes.name
        );

        const price = '+' + montageType.attributes.priceAfterDiscount + `kr`;
        this.uiService.addTextInElement(
            this.uiService.getElementByAttribute('nf-value-key', 'price', option),
            price);

        return option;
    }
}
